import React from 'react';

import styled from 'styled-components';
const authentication = require('react-azure-adb2c2').default;

var moment = require('moment-timezone');
const Balloon = styled.div`
    position:relative;
    padding: 10px 10px 0px 10px;
    border-bottom:1px solid #dcdcdc;
`;
const Faceicon = styled.div`
        
        width: 20px;
`;
const FaceiconImg = styled.img`
    width: 100%;
        height: auto;
        border-radius: 50%;
`;

const DisplayName = styled.div`
    margin:0 25px 0 25px;
    font-size:9px;
    font-weight:bold;
    color:black;
text-align:left;
`;
const Chatting = styled.div`
    width: 100%;
        text-align: left;
`;
const Say = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 25px;

    max-width: 250px;
    max-height: 30px;
    background: #edf1ee;
    margin-bottom: 2px;
overflow: hidden;
    font-size:9px;
    
}
`;

const MsgArea = styled.p`
    margin: 0;
        padding: 0;
`;



export default class LineImgComponent extends React.Component {
    constructor(props) {
        super(props)
        const dt = new Date(this.props.msg.date)
        this.state = {
            date_time: (dt.getMonth() + 1) + "/" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes(),
            bloburl: "",
        };

    }

    componentWillMount() {

        if(this.props.msg.file_id && this.props.msg.message_type == "image"){
            
            const token = authentication.getAccessToken();
            var url = ""
            if(this.props.msg.replytoken == "globalcenter"){
                url = `https://homestatonlineapi.azurewebsites.net/v1/lines/getsendfile/` + this.props.msg.file_id
            }else{
                url = `https://homestatonlineapi.azurewebsites.net/v1/lines/getfile/` + this.props.msg.file_id
            }
            
            
            // const url = `http://localhost:5000/v1/lines/getfile/` + this.props.msg.file_id
            // alert(url)

            var bloburl
            fetch(url, {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token }
            }).then(response => response.blob()).then(images => {
                // Then create a local URL for that image and print it 
                bloburl = URL.createObjectURL(images)
                console.log(bloburl)
                this.setState({
                    bloburl: bloburl
                })

            });
        }

    }

    render() {
        return (
<>
            <div style={{display:"flex", padding:"10px 10px 3px 10px", borderBottom: this.props.type == "sticker" ? "" : "1px solid #dcdcdc",}}>
                <div>
                    {this.props.msg.replytoken === 'globalcenter' ? <Faceicon></Faceicon>
                    :
                    <Faceicon><FaceiconImg src={'https://img.global-center.co.jp/v1/line/img/' + this.props.msg.line_user_id + '/200/200'} /></Faceicon>}
                    

                </div>
                <div style={{fontSize:"9px", paddingLeft:"5px"}}>
                        <div style={{fontWeight:"bold"}}>{this.props.msg.replytoken === 'globalcenter' ? "Global Center" : this.props.msg.display_name}</div>
                        <div style={{

display: "inline-block", maxHeight: "30px", maxWidth: "250px", overflow: "hidden"


                        }}>
                            {this.props.msg.message_type == "text" ? 
                                <span style={{display: "inline-block", maxHeight: "30px"}} dangerouslySetInnerHTML={{ __html: this.props.msg.message_text.replace(/\r?\n/g, '<br/>') }} />
                            :
                            this.props.msg.message_type == "sticker" ? 
                                "スタンプ"
                            :
                            this.props.msg.message_type == "file" ? 
                                this.props.msg.message_text
                            :
                            this.props.msg.message_type == "image" ? 
                                "画像"
                            :
                            this.props.msg.message_type == "applicationform" ? 
                                "お申込みページのご案内"
                            :
                            this.props.msg.message_type == "transferform" ? 
                                "口座振替受付サービスのご案内"
                            :""}
                        </div>
                </div>
                <div style={{paddingLeft:"10px"}}>
                    {this.props.msg.message_type == "sticker" ? 
                                <img style={{}} width="30px" src={"https://stickershop.line-scdn.net/stickershop/v1/sticker/"+this.props.msg.message_text+"/iPhone/sticker_key@2x.png"} />

                    :this.props.msg.message_type == "image" ? 
                                <img style={{}} width="30px" src={this.state.bloburl} />
                            :""}

                </div>
            </div>
</>
        )
    }
}
